/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Sanitize } from 'src/DistributionPackages/BestFit.Magicline/Resources/Private/App/Components/Sanitizer';
import PropTypes from 'prop-types';

/**
 * CheckoutSuccess Component
 * @param props
 * @returns {Element}
 * @constructor
 */
function CheckoutSuccess(props) {
  const { confirmationContent } = props;

  /**
     * Dispatches a custom event 'checkoutVideoInitialized' to signal that a video has been initialized.
     *
     * This function creates a new custom event named 'checkoutVideoInitialized' using the Event constructor.
     * Once the event is created, it is dispatched to the global `window` object, allowing any listeners
     * attached to this event to respond accordingly.
     *
     * Usage:
     * This function can be used to notify other parts of the application when a video
     * has been initialized or is ready for interaction.
     *
     * No parameters are required, and no return value is expected.
     */
  const videoInitialized = () => {
    const customEvent = new Event('checkoutVideoInitialized');
    window.dispatchEvent(customEvent);
  };

  return (
    <>
      <Sanitize value={confirmationContent} />
      {videoInitialized()}
    </>
  );
}

export default CheckoutSuccess;

CheckoutSuccess.propTypes = {
  confirmationContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};
